import React from "react";
import tick from "../Assets/06ae072fb343a704ee80c2c55d2da80a.gif";
import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";

const ServicesSuccess = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <div className="services-success-page" style={styles.container}>
        <img className="tick" src={tick} alt="Payment successful" />
        <h2>Payment Successful!</h2>
        <p>Your transaction was successful.</p>
        <button onClick={() => navigate("/")} className="complete-btn">
          Go To Home
        </button>
      </div>
      <Footer />
    </>
  );
};

const styles = {
  container: { textAlign: "center", marginTop: "50px" },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    marginTop: "20px",
    cursor: "pointer"
  }
};

export default ServicesSuccess;
